<template>
    <div class="float-l width-full">
        <div class="header-section col-12 float-l bgcolor-cfe3ee"> <!--header section-->
            <div class="back-btn-chat float-l">
                <a href="#"> <i class="hi-icon icon-chatback"></i> </a>
            </div>

            <div class="customer-name float-l colpie-87">
                <a class="back-btn-main" v-on:click.prevent="backButton()"> <i class="hi-icon icon-chatback "></i> </a>
                <p class="user-avtar-archived-img user-avtar-img float-l font-roboto-bold heading-text-14 line-height-16 bgcolor-d7b081 color-white"> <img src="/static/images/default-img.png"> </p>
                <p class="user-avtar-archived-img color-231f20 font-roboto-bold heading-text-16 line-height-20 agent-customer-name float-l width-full pt_10 pl_100 mb_0"> {{fullName}}
                </p>
            </div>
            <div class="menu-right-header float-r"> <!--header menu section-->
                <div class="nc-chat-right-dropdown">
                    <div class="dropdown">
                        <button class="more-btn btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">
                            <span class="more-dot"></span>
                            <span class="more-dot"></span>
                            <span class="more-dot"></span>
                        </button>

                        <ul class="dropdown-menu">
                            <li> <a href="#" data-toggle="modal" data-target="#basicModal1"> Email Chat <span> <i class="fa fa-angle-right custom" ></i> </span> </a> </li>
                            <li> <a href="#" data-toggle="modal" data-target="#basicModal"> Forward Chat <span> <i class="fa fa-angle-right custom" ></i> </span> </a> </li>
                            <li> <a href="#"> End Chat <span> <i class="fa fa-angle-right custom" ></i> </span> </a> </li>
                        </ul>
                    </div>
                </div>
            </div> <!--header menu section-->
        </div> <!--header section-->

        <div class="chat-btm-section-main chat-listing-main-mobile width-full float-l message-height">
            <div class="chat-detail-main col-12 float-l">
                <template v-if="messageArrData && messageArrData.length > 0" v-for="(message, index) in messageArrData">
                                            
                    <div class="user-chat-main colpie-85 float-l" v-if="message.fromRole == 'guest'" :key="index"> <!--user chat-->
                        <div class="user-img float-l">
                            <img src="/static/images/default-img.png" alt="User Name">
                        </div>

                        <div class="user-massage float-l width-full">
                            <p class="message-content color-333333 heading-text-14 line-height-20 float-l bgcolor-eff1f1 font-text-regular-benton radius-5 pt_10 p_12 mb_0" v-html="message.message"> </p>
                            <p class="date color-888888 heading-text-11 line-height-16 float-l width-full font-text-regular-benton mb_0 pt_5 pl_12">{{message.created_date | filterDate}}</p>
                        </div>
                    </div> <!--user chat-->

                    <div class="admin-chat-main colpie-82 float-r" v-else :key="index"> <!--admin chat-->
                        <div class="user-massage float-r width-full">
                            <p class="message-content color-333333 heading-text-14 line-height-20 float-r bgcolor-d6eef5 font-text-regular-benton radius-5 pt_10 p_12 mb_0" v-html="message.message"></p>
                            <p class="date color-888888 heading-text-11 line-height-16 float-r right width-full font-text-regular-benton mb_0 pt_5 pr_12">{{message.created_date | filterDate}}</p>
                        </div>
                    </div> <!--admin chat-->
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import Footer from "@/components/partials/Footer";
    import {HTTP} from '../../http-common';
    import {commonMixins} from '../../mixins/commonMixins';
    import moment from 'moment';
    import EventBus from '../event-bus';
    var self;
    Vue.component("app-footer", Footer);
    export default {
        props: ['chatWindowData', 'flag', 'fromId', 'toId', 'date'],
        name: 'ChatWindow',
        mixins: [commonMixins],
        data () {
            return {
                logingId: 0,
                messageArrData:[],
                customerName: "",
                userName: "",
                fullName: "Loading",
            }
        },
        mounted: function() {
            var self = this;
            var userObj = localStorage.getItem('user_obj');
            self.status = localStorage.getItem('status');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
                self.logingId = userJson["id"];
                self.userName = userJson['name'];
            }
            if(self.flag == 'detailWindow' && self.fromId && self.toId) {
                self.loadChat(self.fromId, self.toId);
            }
            self.messageArrData = self.chatWindowData;
        },
        filters: {
            filterDate(date) {
                if (date) {
                    var splitDate = date.split(",");
                    return splitDate[1];
                } else {
                    return '';
                }
            }
        },
        methods: {
            backButton: function() {
                this.$parent.getArchivedChat();
            },
            loadChat: function(getFromId, getToId) {
                var self = this;
                var date = moment(self.date).format('YYYY-MM-DD');
                // 2019-07-17 23:59:59
                var fields = {
                    fromId: getFromId,
                    toId: getToId,
                    flag: 'web',
                    fromdate: date+" 00:00:00",
                    todate: date+" 23:59:59",
                };

                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                HTTP.post("get-archive-chat", fields, config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                self.fullName = "Loading";
                                if (response.data.content != "") {
                                    self.messageArrData = response.data.content;
                                    if(self.messageArrData && self.messageArrData.length > 0) {
                                        self.customerName = self.messageArrData[0].fromName;
                                        self.userName = self.messageArrData[0].toName;
                                        self.fullName = self.customerName + " - " + self.userName;
                                    }
                                    setTimeout(function() {
                                        // $("body").animate({ scrollTop: $(".message-height").height() }, 1000);
                                        $(".message-height").animate({ 
                                            scrollTop: $(".message-height").prop("scrollHeight")
                                        }, 500);
                                    }, 200);
                                }
                            }
                        })
                        .catch(function (error) {
                            self.catchHandler(error, function () {});
                        });
            }
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .user-avtar-img img {
        width: 100%;
        height: 100%;
        border-radius: 100%;
        vertical-align: top;
    }
</style>


// WEBPACK FOOTER //
// src/components/List/ChatWindow.vue